// extracted by mini-css-extract-plugin
module.exports = {"info":"FormInfo_info__b8Hrp","item":"FormInfo_item__Wg9iO","info-label":"FormInfo_info-label__6DRpj","info-text":"FormInfo_info-text__S58_x"};